function toFiniteNumber(value: unknown, fallback: number): number {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

function clampTrackIndex(value: unknown): number {
  return Math.max(0, Math.min(3, Math.round(toFiniteNumber(value, 0))))
}

function trimTrailingZeros(value: number): string {
  return String(Number(value.toFixed(3)))
}

export function ensureAudioPlayParameters(parameter?: string[] | null): string[] {
  const source = Array.isArray(parameter) ? [...parameter] : []
  const normalized = ['', '50', '', '2', '0', '0', '1', '0', '0']
  for (let index = 0; index < Math.min(source.length, normalized.length); index += 1) {
    normalized[index] = source[index] ?? normalized[index]
  }
  if (!normalized[6]) normalized[6] = '1'
  if (!normalized[7]) normalized[7] = '0'
  if (!normalized[8]) normalized[8] = '0'
  return normalized
}

export function readAudioPlaySeconds(parameter?: string[] | null): number {
  const normalized = ensureAudioPlayParameters(parameter)
  if (normalized[6] === '1') {
    const precise = toFiniteNumber(normalized[7], Number.NaN)
    if (Number.isFinite(precise)) return Math.max(0, precise)
    return Math.max(0, toFiniteNumber(normalized[5], 0) / 60)
  }
  return Math.max(0, toFiniteNumber(normalized[5], 0))
}

export function writeAudioPlaySeconds(parameter: string[] | null | undefined, value: number): string[] {
  const normalized = ensureAudioPlayParameters(parameter)
  const seconds = Math.max(0, toFiniteNumber(value, 0))
  normalized[5] = String(Math.round(seconds * 60))
  normalized[6] = '1'
  normalized[7] = trimTrailingZeros(seconds)
  return normalized
}

export function readAudioPlayTrack(parameter?: string[] | null): number {
  const normalized = ensureAudioPlayParameters(parameter)
  return clampTrackIndex(normalized[8])
}

export function writeAudioPlayTrack(parameter: string[] | null | undefined, value: number): string[] {
  const normalized = ensureAudioPlayParameters(parameter)
  normalized[8] = String(clampTrackIndex(value))
  return normalized
}

export function ensureAudioFadeParameters(parameter?: string[] | null): string[] {
  const source = Array.isArray(parameter) ? [...parameter] : []
  const normalized = ['0', '', '0']
  for (let index = 0; index < Math.min(source.length, normalized.length); index += 1) {
    normalized[index] = source[index] ?? normalized[index]
  }
  return normalized
}

export function readAudioFadeSeconds(parameter?: string[] | null): number {
  const normalized = ensureAudioFadeParameters(parameter)
  return Math.max(0, toFiniteNumber(normalized[0], 0))
}

export function writeAudioFadeSeconds(parameter: string[] | null | undefined, value: number): string[] {
  const normalized = ensureAudioFadeParameters(parameter)
  normalized[0] = trimTrailingZeros(Math.max(0, toFiniteNumber(value, 0)))
  return normalized
}

export function readAudioFadeTrack(parameter?: string[] | null): number {
  const normalized = ensureAudioFadeParameters(parameter)
  return clampTrackIndex(normalized[2])
}

export function writeAudioFadeTrack(parameter: string[] | null | undefined, value: number): string[] {
  const normalized = ensureAudioFadeParameters(parameter)
  normalized[2] = String(clampTrackIndex(value))
  return normalized
}
